export default "/images/android_service__upper.png";